export function getBrowserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

export function parseDateValue(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateTime(value, options = {}) {
  const date = parseDateValue(value);
  if (!date) return "—";

  const resolvedOptions = {
    dateStyle: "medium",
    timeStyle: "short",
    ...options,
  };

  return new Intl.DateTimeFormat(undefined, resolvedOptions).format(date);
}

export function formatDateOnly(value, options = {}) {
  const date = parseDateValue(value);
  if (!date) return "—";

  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    ...options,
  }).format(date);
}

export function formatDateTimeForTimeZone(value, timeZone, options = {}) {
  const date = parseDateValue(value);
  if (!date) return "—";

  return new Intl.DateTimeFormat(undefined, {
    ...options,
    timeZone,
  }).format(date);
}
